export { default } from './ProcessColorChip';
